import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ThemeMode = 'light' | 'dark';
/** Pieles del UI (decisión 27-ago): mismas pantallas, distinta identidad visual.
 *  Base del white-label §34.6 — más adelante la firma fija la suya. */
export type Skin = 'aurora' | 'ledger' | 'institutional' | 'privatebank';
export const SKINS: Skin[] = ['aurora', 'ledger', 'institutional', 'privatebank'];

interface ThemeState {
  mode: ThemeMode;
  skin: Skin;
  toggle: () => void;
  setMode: (mode: ThemeMode) => void;
  setSkin: (skin: Skin) => void;
}

// Premium dark/light theme store with persistence + <html class/data-skin> sync.
export const useTheme = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: 'dark',
      skin: 'aurora',
      toggle: () => {
        const next = get().mode === 'dark' ? 'light' : 'dark';
        applyTheme(next, get().skin);
        set({ mode: next });
      },
      setMode: (mode) => {
        applyTheme(mode, get().skin);
        set({ mode });
      },
      setSkin: (skin) => {
        applyTheme(get().mode, skin);
        set({ skin });
      },
    }),
    {
      name: 'vaultex-theme',
      onRehydrateStorage: () => (state) => {
        applyTheme(state?.mode ?? 'dark', state?.skin ?? 'aurora');
      },
    },
  ),
);

function applyTheme(mode: ThemeMode, skin: Skin) {
  const root = document.documentElement;
  root.classList.toggle('dark', mode === 'dark');
  root.style.colorScheme = mode;
  // 2-nov (web-interface-guidelines): la barra del navegador sigue al tema.
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', mode === 'dark' ? '#0b1220' : '#f8fafc');
  if (skin === 'aurora') delete root.dataset.skin;
  else root.dataset.skin = skin;
}
